import { useCallback, useEffect, useMemo, useState } from 'react'
import { useUserContext } from '../../user/UserContext'
import { apiFetch } from '../../utility/fetch'
import { DateTime } from 'luxon'
import { useLoading } from '../../loading/LoadingContext'

export interface UseAmazonFedExDeliveryMetricsPostContext {
  uploadFile: any
  fedexDeliveryMetricsPostError: any
}

const useAmazonFedExDeliveryMetricsPost = (file, userData, setTriggerRefresh): UseAmazonFedExDeliveryMetricsPostContext => {
  const {toggleLoading, changeStep, changeSubStep} = useLoading()
  const [currentError, setCurrentError] = useState(undefined)

  const uploadFile = async () => {
    if (!file) {
      alert('Please select a file to upload.')
      return
    }

    const reader = new FileReader()

    reader.onload = async (event) => {
      changeStep('Posting Amazon Fedex Delivery Metrics')
      changeSubStep(`Uploading and processing file.`)
      toggleLoading(true)
      // If the validation passes, proceed to upload
      const formData = new FormData()
      formData.append('csvContent', file)

      try {
        const response = await apiFetch({
          endpoint: 'amazonFedExDeliveryMetrics',
          method: 'POST',
          accessToken: userData.accessToken,
          headers: { 'Content-Type': 'multipart/form-data' },
          body: formData
        })
        if(!response.ok){
          console.error(response.status, response.statusText, response.body)
          setCurrentError(JSON.stringify({status: response.status, statusText: response.statusText, body: response.body}))
        }
        setTriggerRefresh(DateTime.now().toMillis())
      } catch (error) {
        console.error('Error uploading file:', error)
        setCurrentError(error)
      } finally {
        toggleLoading(false)
      }
    }

    reader.onerror = (error) => {
      console.error('Error reading file:', error)
      setCurrentError(error)
      toggleLoading(false)
      alert('Error reading file. Please try again.')
    }

    reader.readAsText(file)
  }

  const context: UseAmazonFedExDeliveryMetricsPostContext = useMemo(() => {
    return {
      uploadFile,
      fedexDeliveryMetricsPostError: currentError
    }
  }, [uploadFile])

  return context
}

export default useAmazonFedExDeliveryMetricsPost